import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ChangePasswordModal from '@components/modal/changePasswordModal'
import ProfileModal from '@components/modal/profileModal'
import LogoutModal from '@components/modal/logoutModal'
import InsurerLogo from '@components/insurerLogo'

import { getProfile as getProfileAction } from '@actions/user'

import {
  Title, Container, Separator
} from './styles'

const Header = ({ profile, getProfile, authData }) => {
  const [changePasswordModal, setChangePasswordModal] = useState(false)
  const [profileModal, setProfileModal] = useState(false)

  useEffect(() => {
    getProfile()
  }, [])

  if (!authData) return null

  return (
    <Container>
      <InsurerLogo
        style={{
          height: '27px',
          padding: '0 24px',
          alignSelf: 'center',
        }}
        disableClick={!!(authData.company || authData.programme)}
      />
      <Separator />
      <Title>Saúde Preventiva Empresarial</Title>
      <LogoutModal
        openChangePasswordModal={() => setChangePasswordModal(true)}
        openProfileModal={() => setProfileModal(true)}
        userName={profile && profile.name ? profile.name : ''}
        profile={profile}
        company={authData.insurance && authData.insurance.name}
      />
      <ChangePasswordModal
        isOpen={changePasswordModal}
        setClose={() => setChangePasswordModal(false)}
      />
      <ProfileModal
        isOpen={profileModal}
        setClose={() => setProfileModal(false)}
      />
    </Container>
  )
}

Header.propTypes = {
  authData: PropTypes.shape({
    name: PropTypes.string,
    insurance: PropTypes.shape({
      name: PropTypes.string,
    }),
    company: PropTypes.shape({
      id: PropTypes.number,
    }),
    programme: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  profile: PropTypes.shape({
    name: PropTypes.string,
  }),
  getProfile: PropTypes.func.isRequired,
}

Header.defaultProps = {
  authData: {},
  profile: {
    name: '',
  },
}

const mapStateToProps = ({ user, auth }) => ({
  profile: user.profile,
  authData: auth.data,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getProfile: getProfileAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(Header)
